import { Dispatch } from 'redux';
import {
  ADD_REPORT_TO_USER,
  REMOVE_REPORT_FROM_USER
} from '../../../../users/presentation/redux/types/user-types';
import { TReport } from '../../../definitions';
import { addUserToReport } from '../../../network/add-user-report.network';
import { getReport } from '../../../network/get-report.network';
import { getReports } from '../../../network/get-reports.network';
import { removeUserFromReport } from '../../../network/remove-users-report.network';
import {
  REPORT_ADD_USER_FAILURE,
  REPORT_ADD_USER_REQUEST,
  REPORT_ADD_USER_SUCCESS,
  REPORT_LOAD_FAILURE,
  REPORT_LOAD_REQUEST,
  REPORT_LOAD_SUCCESS,
  REPORT_REMOVE_USER_FAILURE,
  REPORT_REMOVE_USER_REQUEST,
  REPORT_REMOVE_USER_SUCCESS,
  REPORT_SET_SELECTED,
  REPORTS_LOAD_FAILURE,
  REPORTS_LOAD_REQUEST,
  REPORTS_LOAD_SUCCESS
} from '../types/reports-types';

export const getReportsAction = (token: string) => {
  return async (dispatch: Dispatch) => {
    dispatch({ type: REPORTS_LOAD_REQUEST });

    try {
      const reports = await getReports(token);

      dispatch({ type: REPORTS_LOAD_SUCCESS, payload: reports });
    } catch (error) {
      console.log(error);
      dispatch({ type: REPORTS_LOAD_FAILURE, error });
    }
  };
};

export const setReportAction = (report_id: string) => {
  return async (dispatch: Dispatch) => {
    try {
      dispatch({ type: REPORT_SET_SELECTED, payload: report_id });
    } catch (error) {
      console.log(error);
      dispatch({ type: REPORT_LOAD_FAILURE, error });
    }
  };
};

export const getReportAction = (token: string, report_id: string) => {
  return async (dispatch: Dispatch) => {
    dispatch({ type: REPORT_LOAD_REQUEST });

    try {
      const report = await getReport(token, report_id);

      dispatch({ type: REPORT_LOAD_SUCCESS, payload: report });
    } catch (error) {
      console.log(error);
      dispatch({ type: REPORT_LOAD_FAILURE, error });
    }
  };
};

export const addUserToReportAction = (
  token: string,
  report: TReport,
  permission_ids: string[],
  user_ids: string[]
) => {
  return async (dispatch: Dispatch) => {
    dispatch({ type: REPORT_ADD_USER_REQUEST });

    try {
      await addUserToReport(token, report.id, permission_ids);

      dispatch({ type: ADD_REPORT_TO_USER, payload: { report, user_ids } });
      dispatch({ type: REPORT_ADD_USER_SUCCESS });
    } catch (error) {
      console.log(error);
      dispatch({ type: REPORT_ADD_USER_FAILURE, error });
    }
  };
};

export const removeUserFromReportAction = (
  token: string,
  report: TReport,
  permission_ids: string[],
  user_ids: string[]
) => {
  return async (dispatch: Dispatch) => {
    dispatch({ type: REPORT_REMOVE_USER_REQUEST, payload: user_ids });

    try {
      await removeUserFromReport(token, report.id, permission_ids);

      dispatch({ type: REMOVE_REPORT_FROM_USER, payload: { report, user_ids } });
      dispatch({ type: REPORT_REMOVE_USER_SUCCESS });
    } catch (error) {
      console.log(error);
      dispatch({ type: REPORT_REMOVE_USER_FAILURE, error });
    }
  };
};
